import { XML } from "@goodgamestudios/xml-e4x";
/**
 *
 */
export class BasicAchievementData {
    protected achievementXML: XML;

    constructor(achievementXML: any) {
        this.achievementXML = achievementXML;
    }
}
